import { Routes, Route, Navigate } from 'react-router-dom';
import { ProjectScope } from '../../components/ProjectScope';
import { Dashboard } from './Dashboard';
import { Register } from './Register';
import { Levels } from './Levels';

export function CxRoutes() {
  return (
    <ProjectScope
      storageKey="munin.cx.project"
      emptyBody="Commissioning menggantung pada sebuah proyek dan register peralatannya. Buat proyek lebih dulu."
    >
      {(projectId) => (
        <Routes>
          <Route path="/" element={<Dashboard projectId={projectId} />} />
          <Route path="/register" element={<Register projectId={projectId} />} />
          <Route path="/levels" element={<Levels projectId={projectId} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
    </ProjectScope>
  );
}
